import React, { useEffect, useState } from "react";

// LISA helpers
import { baseUrl } from "../helpers/constants";
import { fetchWrapper } from "../helpers/fetchwrapper";
import { StackShim } from "@fluentui/react-migration-v8-v9";

// Fluent UI v9
import {
  Avatar,
  Body2,
  Button,
  FluentProvider,
  makeStyles,
  Persona,
  Text,
  Tooltip,
} from "@fluentui/react-components";
import {
  Call24Regular,
  Mail24Regular,
  Phone24Regular,
  VideoPersonCall24Regular,
} from "@fluentui/react-icons";

import { shallowEqual, useSelector } from "react-redux";
import { GlobalAppState } from "../store/GlobalAppState";
import { IAppUserDto } from "../Models/IAppUserDto";

const useStyles = makeStyles({
  tooltip: {
    maxWidth: "300px",
  },
});

interface ILuebPersonaProps {
  user: IAppUserDto;
  asAvatar?: boolean;
  asMenuItem?: boolean;
  hideTooltip?: boolean;
}

function LuebPersona(props: ILuebPersonaProps) {
  const styles = useStyles();

  const [showPresenceBadge, setShowPresenceBadge] = useState<boolean>(false);

  return (
    <div>
      <FluentProvider>
        <Tooltip
          visible={props.hideTooltip ? false : undefined}
          relationship="description"
          content={{
            className: styles.tooltip,
            children: (
              <StackShim horizontalAlign="start">
                <div style={{ marginLeft: 10, marginRight: 10 }}>
                  <StackShim
                    horizontal
                    tokens={{ childrenGap: 15 }}
                    verticalAlign="center"
                  >
                    <Avatar
                      name={props.user.fullName}
                      // image={{
                      //   src: `${baseUrl}/api/user/GetThumbnailFoto?samAccountName=${props.user.samAccountName}`,
                      // }}
                      // badge={
                      //   showPresenceBadge
                      //     ? {
                      //         status: presenceStatus,
                      //       }
                      //     : undefined
                      // }
                    />
                    <StackShim>
                      <Body2>{`${props.user.fullName}`}</Body2>
                      <Text>{`${
                        props.user.abteilung ? props.user.abteilung : "n/a"
                      }`}</Text>
                    </StackShim>
                  </StackShim>
                </div>

                <div style={{ marginTop: 10 }}>
                  <StackShim
                    verticalAlign="start"
                    horizontalAlign="start"
                    tokens={{ childrenGap: 1 }}
                  >
                    {props.user.telefonNummer && (
                      <Button
                        appearance="transparent"
                        icon={<Call24Regular />}
                        target="_blank"
                        rel="noreferrer"
                        as="a"
                        href={`callto://${props.user.telefonNummer}`}
                      >
                        {props.user.telefonNummer}
                      </Button>
                    )}

                    {/* {props.user.mobile && (
                      <Button
                        appearance="transparent"
                        icon={<Phone24Regular />}
                        target="_blank"
                        rel="noreferrer"
                        as="a"
                        href={`callto://${props.user.mobile}`}
                      >
                        {props.user.mobile}
                      </Button>
                    )} */}

                    <Button
                      appearance="transparent"
                      icon={<Mail24Regular />}
                      target="_blank"
                      rel="noreferrer"
                      as="a"
                      href={`mailto://${props.user.email}`}
                    >
                      {props.user.email}
                    </Button>

                    {/* {props.user?.roles?.includes("JitsiDirectCall") && (
                      <Button
                        disabled={presenceStatus != "available"}
                        appearance="transparent"
                        icon={<VideoPersonCall24Regular />}
                        onClick={() => startJitsiDirectCall()}
                      >
                        Videoanruf
                      </Button>
                    )} */}
                  </StackShim>
                </div>
              </StackShim>
            ),
          }}
        >
          <div className="fui-persona">
            {!props.asAvatar && (
              <Persona
                name={props.user.fullName}
                secondaryText={props.user.abteilung}
                // presence={
                //   showPresenceBadge
                //     ? {
                //         status: presenceStatus,
                //       }
                //     : undefined
                // }
                // avatar={{
                //   image: {
                //     src: `${baseUrl}/api/user/GetThumbnailFoto?samAccountName=${props.user.samAccountName}`,
                //   },
                // }}
              />
            )}

            {props.asAvatar && (
              <Avatar
                size={props.asMenuItem ? 24 : undefined}
                name={props.user.fullName}
                // image={{
                //   src: `${baseUrl}/api/user/GetThumbnailFoto?samAccountName=${props.user.samAccountName}`,
                // }}
                // badge={
                //   showPresenceBadge
                //     ? {
                //         status: presenceStatus,
                //       }
                //     : undefined
                // }
              />
            )}
          </div>
        </Tooltip>
      </FluentProvider>
    </div>
  );
}

export default LuebPersona;
